import React, { isValidElement } from 'react';
import { createSlice, createAction } from '@reduxjs/toolkit';

export const OPEN_DIALOG = 'OPEN_DIALOG';
export const CONFIRM_DIALOG = 'CONFIRM_DIALOG';
export const CANCEL_DIALOG = 'CANCEL_DIALOG';

type DialogPayload = Record<string, unknown> & { prompt?: unknown };

export const openDialog = createAction(
	OPEN_DIALOG,
	(prompt: unknown = {}, ...args: unknown[]): { payload: DialogPayload } => {
		if (prompt === null || typeof prompt !== 'object' || isValidElement(prompt)) {
			return {
				payload: {
					prompt,
					confirmText: args[0],
					cancelText: args[1],
					renderCancelLink: args[2],
					shouldRenderHelpLink: args[3],
				},
			};
		}
		return { payload: prompt as DialogPayload };
	}
);

export const confirmDialog = createAction(CONFIRM_DIALOG);
export const cancelDialog = createAction(CANCEL_DIALOG);

type DialogState = {
	open: boolean;
	[key: string]: unknown;
};

const initialState: DialogState = { open: false };

const dialogSlice = createSlice({
	name: 'dialog',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(openDialog, (_state, action) => {
				const payload = action.payload ?? {};
				const { prompt, ...rest } = payload;
				const safePrompt = React.isValidElement(prompt)
					? prompt
					: typeof prompt === 'object' && prompt !== null
						? JSON.stringify(prompt)
						: prompt;
				return { ...rest, open: true, prompt: safePrompt };
			})
			.addCase(confirmDialog, () => ({ open: false }))
			.addCase(cancelDialog, () => ({ open: false }));
	},
});

export const { reducer } = dialogSlice;
export default dialogSlice.reducer;
